import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_RECHARGE_REWARD_DIALOG } from "../../store/rechargeReward/types";

//component
import RewardTypeSelector from "../RewardTypeSelector";

//action
import { addRechargeReward } from "../../store/rechargeReward/action";


const RechargeRewardDialog = (props) => {
    const dispatch = useDispatch();

    const { dialog: open, dialogData } = useSelector((state) => state.rechargeReward);


    const [mongoId, setMongoId] = useState("");
    const [reward, setReward] = useState();

    // Reward Type Selector state variables
    const [rewardType, setRewardType] = useState('frame');
    const [selectedFrame, setSelectedFrame] = useState(null);
    const [selectedSvga, setSelectedSvga] = useState(null);
    const [selectedBackground, setSelectedBackground] = useState(null);
    const [selectedGift, setSelectedGift] = useState(null);
    const [selectedGiftCategory, setSelectedGiftCategory] = useState('');
    const [giftQuantity, setGiftQuantity] = useState(0);
    const [validity, setValidity] = useState(1);
    const [validityType, setValidityType] = useState('day');
    const [diamonds, setDiamonds] = useState(1);

    const [errors, setErrors] = useState({
        avatarFrame: "",
        entranceEffect: "",
        background: "",
        diamonds: "",
        validity: "",
        validityType: "",
        gift: "",
    });

    useEffect(() => {
        if (dialogData) {
            setMongoId(dialogData._id);
            setReward(dialogData.reward);
            console.log("Dialog Data:", dialogData);
        }
    }, [dialogData]);

    useEffect(
        () => () => {
            setErrors({
                avatarFrame: "",
                entranceEffect: "",
                background: "",
                diamonds: "",
                validity: "",
                validityType: "",
                gift: "",
            });
            setMongoId("");
            setReward(undefined);
        },
        [open]
    );

    useEffect(() => {
        window.onbeforeunload = () => closePopup();
    }, []);

    const closePopup = () => {
        dispatch({ type: CLOSE_RECHARGE_REWARD_DIALOG });
    };

    const handleSubmit = (e) => {

        const errors = {};
        const data = {};

        if (rewardType === 'frame') {
            if (!selectedFrame) {
                errors.avatarFrame = "Avatar Frame is required.";
                errors.validity = "Validity is required.";
                errors.validityType = "Validity Type is required.";
                return setErrors({ ...errors });
            }
            data.type = 'avatarFrame';
            data.quantity = 1;
            data.validity = parseInt(validity);
            data.validityType = validityType;
            data.avatarFrame = selectedFrame.value;
        }

        if (rewardType === 'svga') {
            if (!selectedSvga) {
                errors.entranceEffect = "Entrance Effect is required.";
                errors.validity = "Validity is required.";
                errors.validityType = "Validity Type is required.";
                return setErrors({ ...errors });
            }
            data.type = 'entranceEffect';
            data.quantity = 1;
            data.validity = parseInt(validity);
            data.validityType = validityType;
            data.entranceEffect = selectedSvga.value;
        }


        if (rewardType === 'background') {
            if (!selectedBackground) {
                errors.background = "Background is required.";
                errors.validity = "Validity is required.";
                errors.validityType = "Validity Type is required.";
                return setErrors({ ...errors });
            }
            data.type = 'background';
            data.quantity = 1;
            data.validity = parseInt(validity);
            data.validityType = validityType;
            data.background = selectedBackground.value;
        }

        if (rewardType === 'diamond') {
            if (!diamonds) {
                errors.diamonds = "Diamonds amount is required.";
                return setErrors({ ...errors });
            }
            data.type = 'diamond';
            data.quantity = parseInt(diamonds);
        }

        if (rewardType === "gift") {
            if (!giftQuantity || giftQuantity <= 0) {
                errors.giftQuantity = "Gift quantity is required."
                return setErrors({ ...errors });
            }
            data.type = 'gift';
            data.quantity = parseInt(giftQuantity);
            data.gift = selectedGift.value;
        }
        const _data = {
            rechargeRewardId: mongoId,
            rewardData: data
        }
        props.addRechargeReward(_data);

        console.log("Final Data to submit:", data);
    }

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                onClose={closePopup}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="responsive-dialog-title">
                    <span className="text-danger font-weight-bold h4"> Add Reward </span>
                </DialogTitle>

                <IconButton
                    style={{
                        position: "absolute",
                        right: 0,
                    }}
                >
                    <Tooltip title="Close">
                        <Cancel className="text-danger" onClick={closePopup} />
                    </Tooltip>
                </IconButton>
                <DialogContent>
                    <div className="modal-body pt-1 px-1 pb-3">
                        <div className="d-flex flex-column">
                            <form>
                                <RewardTypeSelector
                                    rewardType={rewardType}
                                    setRewardType={setRewardType}
                                    validity={validity}
                                    setValidity={setValidity}
                                    validityType={validityType}
                                    setValidityType={setValidityType}
                                    diamonds={diamonds}
                                    setDiamonds={setDiamonds}
                                    giftQuantity={giftQuantity}
                                    setGiftQuantity={setGiftQuantity}
                                    selectedFrame={selectedFrame}
                                    setSelectedFrame={setSelectedFrame}
                                    selectedSvga={selectedSvga}
                                    setSelectedSvga={setSelectedSvga}
                                    selectedBackground={selectedBackground}
                                    setSelectedBackground={setSelectedBackground}
                                    selectedGift={selectedGift}
                                    setSelectedGift={setSelectedGift}
                                    selectedGiftCategory={selectedGiftCategory}
                                    setSelectedGiftCategory={setSelectedGiftCategory}
                                    errors={errors}
                                />

                                <div className="d-flex justify-content-end gap-3 mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closePopup}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={handleSubmit}
                                    >
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default connect(null, { addRechargeReward })(RechargeRewardDialog);
